const schema = {
  Button: '#B37F40',
  Background: '#F2F2F2',
  ExternalFrame: '#2A9D8F',
};

const colors = {
  AppBar: schema.ExternalFrame,
  Button: '#B37F40',
  Background: '#F2F2F2',
  ExternalFrame: '#2A9D8F',
};

export {
  colors,
};
